import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCoronarendererComponent } from './simple-icons-coronarenderer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCoronarendererComponent ],
    exports:      [ SimpleIconsCoronarendererComponent ],
    bootstrap:    []
})
export class SimpleIconsCoronarendererModule {}
